module.exports = __webpack_public_path__ + "static/media/stars.f87c08f5.png";